<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Order Confirmation</h3>
  </div>
  <div class="col-3" (click)="closeDialog()" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
  <!-- <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent(false)" style="color: white; background: red;">CLOSE</button>
  </div> -->
</div>
<br>
<div class="row" style="color: #7b8182; font-size: 21px;">
  <div class="col" style="text-align: right;">
    Order value
  </div>
  <div class="col-4" style="text-align: right;">{{final_price | currency :'INR'}}</div>
  <div class="col-2"></div>
</div><br>
<!-- <div class="row" style="color: #7b8182;font-size: 21px; ">
  <div class="col" style="text-align: right;">
    Current Balance in wallet
  </div>
  <div class="col-4" style="text-align: right;">
    {{wallet_balance | currency : 'INR'}}
  </div>
  <div class="col-2">
  </div>
</div> -->
<!-- <div class="row" *ngIf="wallet_balance > 0" style="color: #7b8182; text-align: center; font-size: 21px;">
  <div class="col" style="margin-top: 30px;">
    <mat-checkbox (change)="walletCheckboxChanged($event)" [(ngModel)]="is_wallet_selected"
      [disabled]="business_type_id == 3 || business_type_id == 5">
    </mat-checkbox> Use wallet balance to pay for this order
  </div>
</div> -->
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row" style="font-size: 21px;">
  <div class="col" style="text-align: right;">
    Amount payable
  </div>
  <div class="col-4" style="text-align: right;">{{final_price_after_wallet | currency :'INR'}}</div>
  <div class="col-2"></div>
</div>
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row" style="font-size: 28px; margin-top: 16%;">
  <div class="col-2" *ngIf="disable_button">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  <!-- <div class="col" style="text-align: center;"
    *ngIf="business_type_id !== 3 && business_type_id !== 5 && business_type_id !== 6 && business_type_id !== 7">
    <button (click)="payClicked()" mat-raised-button style="font-size: 23px;" class="button-class"
      [disabled]="disable_button" id="register_button">Pay
      {{final_price_after_wallet | currency: 'INR'}}</button>
  </div> -->
  <!-- *ngIf="business_type_id == 3 || business_type_id == 5 || business_type_id == 6 || business_type_id == 7" -->
  <div class="col" style="text-align: center;">
    <button (click)="payClicked()" mat-raised-button class="button-class" style="font-size: 23px;"
      [disabled]="disable_button" id="register_button">Finalize
      order</button>
  </div>
</div>
